import { Box } from '@mui/material';
import Header from '../../components/seo/Header';
import Helmet from 'react-helmet';
import Footer from '../../components/seo/Footer';
import { useParams } from 'react-router-dom';
import { DOMTestSearch } from '../../components/seo/DOMTest';
import { DeprecatedSearch } from '../../components/seo/Deprecated';
import { FriendTestSearch } from '../../components/seo/FriendTest';
import { ImageTestSearch } from '../../components/seo/ImageTest';
import { PageObjectsSearch } from '../../components/seo/PageObjects';
import { SPFRecordsSearch } from '../../components/seo/SPFRecords';
import { SecurityTestSearch } from '../../components/seo/SecurityTest';
import { SocialLinksSearch } from '../../components/seo/SocialLinks';
import SocialTags from '../../components/SocialTags';

const SeoSearch = () => {
  const params = useParams();

  const renderComponent = () => {
    switch (params.id) {
      case 'friendliness':
        return <FriendTestSearch />;
      case 'image':
        return <ImageTestSearch />;
      case 'deprecated':
        return <DeprecatedSearch />;
      case 'analysis':
        return <PageObjectsSearch />;
      case 'social':
        return <SocialLinksSearch />;
      case 'dom':
        return <DOMTestSearch />;
      case 'security':
        return <SecurityTestSearch />;
      case 'spfrecords':
        return <SPFRecordsSearch />;
      default:
        return <FriendTestSearch />;
    }
  };
  return (
    <>
      <Helmet>
        <title>
          ReachAI - Business Automation. Build Leads, Get digital powered websites and marketing
          your businesses - Home
        </title>
        <meta
          name="description"
          content="Welcome to ReachAI. Build Leads, Get digital powered websites and marketing your businesses "></meta>
        <meta
          name="keywords"
          content="website development in Cypress, website development in Houston, SEO,website development in Texas,website development near Cypress, website development near 77429, mobile app development near Cypress, android app development near Cypress, ios app development near Cypress, software development, custom software, software solutions, software company, software development company, software developer, software development services, software development agency, software development firm, Digital powered websites, marketing my businesses, reachai, Digital powered websites, marketing my businesses, reachai, ESSL"
        />
        <SocialTags />
      </Helmet>
      <Box sx={styles.main}>
        <Header />
        <Box sx={styles.body}>{renderComponent()}</Box>
        <Footer />
      </Box>
    </>
  );
};

export default SeoSearch;
const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  body: {
    flexGrow: 1,
    maxWidth: '1290px',
    mx: 'auto',
    width: { xs: '90%', lg: '100%' },
    px: 2
  }
};
